var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsights(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "#F39C12",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.698 33.357L16.194 34.2254C15.6867 34.5183 15.513 35.1668 15.8059 35.6739C16.055 36.1055 16.6751 36.3966 17.2545 36.0621L18.7583 35.1938C19.2656 34.9009 19.4394 34.2524 19.1465 33.7452C18.8536 33.2379 18.205 33.0644 17.698 33.357Z",
    fill: "#F39C12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3024 19.2927L47.8063 18.4244C48.3135 18.1315 48.4872 17.483 48.1943 16.9757C47.9014 16.4685 47.2528 16.2947 46.7457 16.5876L45.2418 17.456C44.7346 17.7489 44.5608 18.3974 44.8537 18.9047C45.1029 19.3362 45.7231 19.6274 46.3024 19.2927Z",
    fill: "#F39C12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7586 17.4549L17.2547 16.5865C16.0113 15.929 15.0037 17.6761 16.1941 18.4233L17.698 19.2916C18.2591 19.6155 18.888 19.3515 19.1467 18.9036C19.4395 18.3963 19.2657 17.7478 18.7586 17.4549Z",
    fill: "#F39C12"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8062 34.2255L46.3023 33.3572C45.7951 33.0642 45.1465 33.238 44.8537 33.7453C44.5608 34.2525 44.7346 34.9011 45.2419 35.1939L46.7457 36.0622C47.3147 36.3908 47.9404 36.114 48.1943 35.6741C48.4872 35.1669 48.3135 34.5183 47.8062 34.2255Z",
    fill: "#F39C12"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1583 26.3261C17.1583 25.7404 16.6835 25.2656 16.0979 25.2656H14.962C13.5564 25.3178 13.5575 27.3349 14.962 27.3866H16.0978C16.6835 27.3866 17.1583 26.9117 17.1583 26.3261Z",
    fill: "#F39C12"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0382 25.2656H47.9024C46.4969 25.3178 46.4979 27.3349 47.9024 27.3866H49.0382C50.4438 27.3344 50.4427 25.3173 49.0382 25.2656Z",
    fill: "#F39C12"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2858 31.8917C32.0988 31.944 31.9013 31.944 31.7143 31.8917L29.5605 31.2891L32 38.7973L34.4395 31.2891L32.2858 31.8917Z",
    fill: "#F39C12"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0003 13.9063C25.1523 13.9063 19.5811 19.4775 19.5811 26.3255C19.5811 28.3716 20.6412 30.1135 21.8687 32.1303C23.1956 34.3105 24.6694 36.7342 25.1208 40.1067H30.1962L26.9321 30.0607C26.8113 29.6889 26.9048 29.2809 27.1755 28.9987C27.4461 28.7168 27.85 28.6066 28.2264 28.7117L32.0002 29.7677L35.7741 28.7117C36.5758 28.4776 37.3356 29.2695 37.0684 30.0606L33.8044 40.1068H38.8797C39.3311 36.7343 40.805 34.3106 42.1319 32.1304C43.3594 30.1135 44.4195 28.3716 44.4195 26.3256C44.4195 19.4775 38.8483 13.9063 32.0003 13.9063Z",
    fill: "#F39C12"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9396 48.8827V49.0418C30.9918 50.4474 33.0089 50.4463 33.0605 49.0418V48.8827C36.2748 48.3725 38.7399 45.5822 38.7399 42.2266H25.2603C25.2603 45.5822 27.7254 48.3725 30.9396 48.8827Z",
    fill: "#F39C12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsights);
export default __webpack_public_path__ + "static/media/insights.f31319e1a40225424ef4cdd23ca04cd7.svg";
export { ForwardRef as ReactComponent };